// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName___rAGu","productName":"Table_productName__3INVI"};